import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function RoleManagement() {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    // Roles are embedded in users, so we extract them. 
    // In production, you would add a GET /roles route.
    api.get('/users?limit=100').then(res => {
      const uniqueRoles = [];
      const seen = new Set();
      res.data.data.forEach(u => {
        if (u.role && !seen.has(u.role._id)) {
          seen.add(u.role._id);
          uniqueRoles.push(u.role);
        }
      });
      setRoles(uniqueRoles);
    });
  }, []);

  return (
    <div className="card">
      <h3 className="mb-2">System Roles & Permissions</h3>
      <p className="text-sm text-muted mb-2">Roles are managed at the database level to maintain system integrity. Below is a view of active roles and their permissions.</p>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Role Name</th>
              <th>Modules & Permissions</th>
            </tr>
          </thead>
          <tbody>
            {roles.map(r => (
              <tr key={r._id}>
                <td className="font-bold">{r.name}</td>
                <td>
                  <div className="flex flex-col gap-1">
                    {r.permissions.map((p, i) => (
                      <div key={i} className="p-1" style={{background: '#f8fafc', borderRadius: '4px', fontSize: '12px'}}>
                        <strong>{p.module}:</strong> {p.actions.join(', ')}
                      </div>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}